// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* #components-form-demo-normal-login .login-form {
  max-width: 300px;
}
#components-form-demo-normal-login .login-form-forgot {
  float: right;
}
#components-form-demo-normal-login .ant-col-rtl .login-form-forgot {
  float: left;
}
#components-form-demo-normal-login .login-form-button {
  width: 100%;
} */

.login-div-layout {
  margin: auto;
  max-width: 390px;
  width: 100%;
  margin-top: 20%;
}

.login-container {
  width: 100%;
  display: flex;
}

.login-sub-container-by-half {
  display: flex;
  flex: 1 1; /* Each div takes up equal space */
  height: 100vh; /* Just for illustration - set a height for the example */
  box-sizing: border-box; /* Include padding and borders in the width */
  vertical-align: middle;
  align-items: center;
  justify-content: center;
}

.login-right-form-styling-container {
  border-right-width: inherit;
  border-right-style: inset;
  background-color: #15655d0f;
  border-right-color: #15655d0f;
}

.bg-color {
  height: 100vh;
}

.bg-image {
  height: 70%;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(
    0,
    0,
    0,
    0.5
  ); /* Adjust the last value (0.5) for opacity (0 to 1) */
}

.left-container-div {
  display: flex;
  flex-direction: column;
  justify-content: center; /* Center horizontally */
  align-items: center; /* Center vertically */
}

.assetmart-header-image {
  width: 55%;
  margin-bottom: 2%;
}

.login-form-container {
  display: block;
  margin-top: 2%;
  width: 100%;
  padding: 1% 31% 1% 31%;
}

.login-button-container {
  margin-top: 6%;
}
`, "",{"version":3,"sources":["webpack://./src/dist/style/login.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;GAWG;;AAEH;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAO,EAAE,kCAAkC;EAC3C,aAAa,EAAE,yDAAyD;EACxE,sBAAsB,EAAE,6CAA6C;EACrE,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;;;GAKC,EAAE,qDAAqD;AAC1D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB,EAAE,wBAAwB;EACjD,mBAAmB,EAAE,sBAAsB;AAC7C;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* #components-form-demo-normal-login .login-form {\n  max-width: 300px;\n}\n#components-form-demo-normal-login .login-form-forgot {\n  float: right;\n}\n#components-form-demo-normal-login .ant-col-rtl .login-form-forgot {\n  float: left;\n}\n#components-form-demo-normal-login .login-form-button {\n  width: 100%;\n} */\n\n.login-div-layout {\n  margin: auto;\n  max-width: 390px;\n  width: 100%;\n  margin-top: 20%;\n}\n\n.login-container {\n  width: 100%;\n  display: flex;\n}\n\n.login-sub-container-by-half {\n  display: flex;\n  flex: 1; /* Each div takes up equal space */\n  height: 100vh; /* Just for illustration - set a height for the example */\n  box-sizing: border-box; /* Include padding and borders in the width */\n  vertical-align: middle;\n  align-items: center;\n  justify-content: center;\n}\n\n.login-right-form-styling-container {\n  border-right-width: inherit;\n  border-right-style: inset;\n  background-color: #15655d0f;\n  border-right-color: #15655d0f;\n}\n\n.bg-color {\n  height: 100vh;\n}\n\n.bg-image {\n  height: 70%;\n}\n\n.overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(\n    0,\n    0,\n    0,\n    0.5\n  ); /* Adjust the last value (0.5) for opacity (0 to 1) */\n}\n\n.left-container-div {\n  display: flex;\n  flex-direction: column;\n  justify-content: center; /* Center horizontally */\n  align-items: center; /* Center vertically */\n}\n\n.assetmart-header-image {\n  width: 55%;\n  margin-bottom: 2%;\n}\n\n.login-form-container {\n  display: block;\n  margin-top: 2%;\n  width: 100%;\n  padding: 1% 31% 1% 31%;\n}\n\n.login-button-container {\n  margin-top: 6%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
